import React, { useState, useEffect } from 'react'

const LoadingIndicator = () => {
  const [opacity, setOpacity] = useState(1)

  useEffect(() => {
    const interval = setInterval(() => {
      setOpacity((prev) => (prev === 1 ? 0 : 1))
    }, 500)

    return () => clearInterval(interval)
  }, [])

  return (
    <div
      style={{
        height: '50px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: opacity,
        transition: 'opacity 0.3s ease-in',
      }}>
      <div style={{ width: '30px', height: '30px', borderRadius: '50%', background: '#404040' }}></div>
    </div>
  )
}

export default LoadingIndicator
